module.exports = __webpack_public_path__ + "img/noble-level1-img.6522fb39.png";